import { setModalType, setTaskDetailResMsg } from '../actions/taskDetailActions';
import baseApi from '../api/baseApi';
import { sentryCaptureException } from '../utils/sentryUtils';

/***************************************** API *****************************************/
const drakeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadToDrake: builder.mutation({
      query: ({ taskId }) => ({
        url: 'drake/upload-to-drake',
        method: 'POST',
        body: { taskId, updateReason: 'Drake upload via QDeck' }
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          dispatch(setModalType(null));
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
          dispatch(
            setTaskDetailResMsg({
              error: e?.data?.msg || 'Error occurred',
              title: 'Error running Drake upload'
            })
          );
        }
      }
    }),
    updateDrakeAmounts: builder.mutation({
      query: ({ taskId }) => ({
        url: 'drake/extract-drake-amount',
        method: 'POST',
        body: { taskId, sendNotification: false }
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          dispatch(setModalType(null));
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
          dispatch(
            setTaskDetailResMsg({
              error: e?.data?.msg || 'Error occurred',
              title: 'Error updating Drake amounts'
            })
          );
        }
      }
    })
  })
});

/***************************************** HOOKS *****************************************/
export const { useUploadToDrakeMutation, useUpdateDrakeAmountsMutation } = drakeApi;
